document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.credo-episodes')

  blocks.forEach((block) => {
    const tabs = block.querySelectorAll('.credo-episodes__tab')
    const seasons = block.querySelectorAll('.credo-episodes__season')
    const items = block.querySelectorAll('.credo-episodes__item')

    // ── Scroll reveal ─────────────────────────────────────────────────
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.15) return
          entry.target.classList.add('is-visible')
          obs.unobserve(entry.target)
        })
      },
      { threshold: [0, 0.15, 0.3], rootMargin: '0px 0px -8% 0px' },
    )
    items.forEach((item) => io.observe(item))

    // ── Tab váltás ────────────────────────────────────────────────────
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.season
        tabs.forEach((t) => t.classList.remove('is-active'))
        tab.classList.add('is-active')
        seasons.forEach((s) => {
          s.classList.toggle('is-active', s.dataset.season === target)
        })
      })
    })

    // ── Read more / Bezárás ───────────────────────────────────────────
    block.querySelectorAll('.credo-episodes__read-more').forEach((btn) => {
      btn.addEventListener('click', () => expandCard(btn.dataset.target, block))
    })
    block.querySelectorAll('.credo-episodes__close').forEach((btn) => {
      btn.addEventListener('click', () => collapseCard(btn.dataset.target, block))
    })
  })
})

// ── Expand ────────────────────────────────────────────────────────────
function expandCard(epId, block) {
  const card = block.querySelector(`[data-ep-id="${epId}"]`)
  if (!card) return

  const expanded = card.querySelector('.credo-episodes__excerpt-expanded')
  const readMoreBtn = card.querySelector('.credo-episodes__read-more')
  const closeBtn = card.querySelector('.credo-episodes__close')

  const isMobile = window.innerWidth < 768

  if (!isMobile) {
    const isRight = card.classList.contains('is-right')
    const siblings = getSiblings(card)
    const beforeRects = siblings.map((s) => s.getBoundingClientRect())

    card.classList.add('is-expanded')
    card.style.gridTemplateColumns = isRight ? '1fr 460px' : '460px 1fr'

    requestAnimationFrame(() => {
      flipPush(siblings, beforeRects)
    })
  }

  if (expanded) {
    expanded.setAttribute('aria-hidden', 'false')
    expanded.style.display = 'inline'
    // dupla rAF – biztosan látja a böngésző a display változást
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        expanded.style.opacity = '1'
      })
    })
  }

  // Gomb csere – mindkét esetben (mobil + desktop)
  if (readMoreBtn) {
    readMoreBtn.setAttribute('aria-expanded', 'true')
    readMoreBtn.style.display = 'none'
  }
  if (closeBtn) {
    closeBtn.setAttribute('aria-hidden', 'false')
    closeBtn.style.display = 'inline-flex'
    // dupla rAF – opacity animáció mobilon is lefut
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        closeBtn.style.opacity = '1'
      })
    })
  }
}

// ── Collapse ──────────────────────────────────────────────────────────
function collapseCard(epId, block) {
  const card = block.querySelector(`[data-ep-id="${epId}"]`)
  if (!card) return

  const expanded = card.querySelector('.credo-episodes__excerpt-expanded')
  const readMoreBtn = card.querySelector('.credo-episodes__read-more')
  const closeBtn = card.querySelector('.credo-episodes__close')

  const isMobile = window.innerWidth < 768

  if (!isMobile) {
    const isRight = card.classList.contains('is-right')
    const siblings = getSiblings(card)
    const beforeRects = siblings.map((s) => s.getBoundingClientRect())

    card.classList.remove('is-expanded')
    card.style.gridTemplateColumns = isRight ? '1fr 310px' : '310px 1fr'

    requestAnimationFrame(() => {
      flipPush(siblings, beforeRects)
    })
  }

  if (expanded) {
    expanded.style.opacity = '0'
    setTimeout(() => {
      expanded.setAttribute('aria-hidden', 'true')
      expanded.style.display = 'none'
    }, 150)
  }

  // Gomb csere – mindkét esetben (mobil + desktop)
  if (readMoreBtn) {
    readMoreBtn.setAttribute('aria-expanded', 'false')
    readMoreBtn.style.display = 'inline-flex'
  }
  if (closeBtn) {
    closeBtn.setAttribute('aria-hidden', 'true')
    closeBtn.style.display = 'none'
  }
}

// ── FLIP push helper ──────────────────────────────────────────────────
/**
 * FLIP technika: megmérjük a siblings helyzetét ELŐTTE és UTÁNA,
 * majd a különbséget azonnal "visszarakjuk" transform-mal (INVERT),
 * végül egy frame-ben nullára animáljuk (PLAY) – ez adja a
 * teljesen sima, darabmentes mozgást.
 */
function flipPush(siblings, beforeRects) {
  const afterRects = siblings.map((s) => s.getBoundingClientRect())

  siblings.forEach((sib, i) => {
    const dy = beforeRects[i].top - afterRects[i].top
    if (Math.abs(dy) < 1) return

    const delay = i * 10 // minimális stagger

    sib.style.transition = 'none'
    sib.style.transform = `translateY(${dy}px)`

    requestAnimationFrame(() => {
      sib.style.transition = `transform 0.12s ${delay}ms cubic-bezier(0.4, 0, 0.2, 1)`
      sib.style.transform = 'translateY(0)'
    })
  })
}

// ── Siblings lekérése ─────────────────────────────────────────────────
function getSiblings(card) {
  const season = card.closest('.credo-episodes__season')
  if (!season) return []
  const all = Array.from(season.querySelectorAll('.credo-episodes__item'))
  const index = all.indexOf(card)
  return all.slice(index + 1)
}
